import { keymap } from '@atlaskit/editor-common/keymaps';
import { EditorState } from '@atlaskit/editor-prosemirror/state';

import { getEditor } from '../codemirrorRegistry';

const isCodeSuggestionNode = (node: any) =>
  node?.type?.name === 'extension' &&
  node.attrs?.extensionKey === 'codesuggestions:suggestion-node';

const focusCodeMirrorAtEnd = (codeMirrorEditor: any) => {
  setTimeout(() => {
    codeMirrorEditor.focus();
    const lastLine = codeMirrorEditor.lineCount() - 1;
    const lastCh = codeMirrorEditor.getLine(lastLine)?.length ?? 0;
    codeMirrorEditor.setCursor({ line: lastLine, ch: lastCh });
  }, 0);
};

const maybeFocusCodeMirrorAtEnd = (node: any): boolean => {
  if (isCodeSuggestionNode(node)) {
    const codeMirrorEditor = getEditor(node?.attrs.localId);
    if (codeMirrorEditor) {
      focusCodeMirrorAtEnd(codeMirrorEditor);
      return true;
    }
  }
  return false;
};

export const createFocusCodeSuggestionsPlugin = () =>
  keymap({
    ArrowDown: (state: EditorState) => {
      const nextPos = state.selection.$from.after();
      const nextNode = state.doc.nodeAt(nextPos);
      return maybeFocusCodeMirrorAtEnd(nextNode);
    },

    ArrowUp: (state: EditorState) => {
      const { doc, selection } = state;
      const currentPos = selection.$from.pos;

      let found = false;
      let foundNode: any = null;

      // Traverse all nodes because direct sibling lookup
      // may miss nested or adjacent suggestion nodes.
      doc.descendants((node, pos) => {
        if (pos < currentPos && isCodeSuggestionNode(node)) {
          found = true;
          foundNode = node;
        }
        return !found; // Stop traversal early if found
      });

      if (found && foundNode) {
        return maybeFocusCodeMirrorAtEnd(foundNode);
      }

      return false;
    },
  });
